import { __makeTemplateObject } from "tslib";
import { keyframes } from '@yunex/yds-react';
export var BOTTOM_LEFT_MENU_POS = {
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
    },
    transformOrigin: {
        vertical: 'top',
        horizontal: 'right',
    },
};
var fadeIn = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    0% { opacity: 0;}\n    100% {opacity: 1;}\n"], ["\n    0% { opacity: 0;}\n    100% {opacity: 1;}\n"])));
export var FADE_IN_ANIMATION = "".concat(fadeIn, " 0.1s ease-in-out");
// TODO - IMPORT FROM YDS-REACT when available
export var GRID_ROW_HEIGHT_LARGE = 57;
var templateObject_1;
//# sourceMappingURL=consts.js.map